import {NgModule} from '@angular/core';
import {AddResourceDialogComponent} from './add-resource-dialog.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatDialogModule} from '@angular/material/dialog';
import {ReactiveFormsModule} from '@angular/forms';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatPseudoCheckboxModule} from '@angular/material/core';
import {ScrollingModule} from '@angular/cdk/scrolling';
import {Q9HtmlDecoderPipe} from '@q9elements/ui-kit/common';
import {
  ContentLoaderComponent,
  DialogCloseButtonComponent,
  InfoMessageComponent,
  LinkButtonComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent,
  SelectModule,
  TextareaFieldComponent,
  TextFieldComponent
} from '@q9elements/ui-kit/components';
import {FilterResourceListPipe} from './pipes/filter-resource-list.pipe';
import {DisplayResourcePipe} from './pipes/display-resource.pipe';
import {DisplaySystemPipe} from './pipes/display-system.pipe';
import {ResourcesDaoService} from './services/resources-dao.service';
import {CommonModule} from '@angular/common';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatInputModule} from '@angular/material/input';
import {CreateResourceDialogComponent} from './components/create-resource-dialog/create-resource-dialog.component';
import {ImageCropperModule} from 'ngx-image-cropper';

@NgModule({
  declarations: [AddResourceDialogComponent, CreateResourceDialogComponent],
  imports: [
    CommonModule,
    TranslateModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatSlideToggleModule,
    MatPseudoCheckboxModule,
    ScrollingModule,
    MatInputModule,
    DialogCloseButtonComponent,
    TextFieldComponent,
    SelectModule,
    LinkButtonComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent,
    Q9HtmlDecoderPipe,
    FilterResourceListPipe,
    DisplayResourcePipe,
    DisplaySystemPipe,
    MatFormFieldModule,
    TextareaFieldComponent,
    ImageCropperModule,
    ContentLoaderComponent,
    InfoMessageComponent
  ],
  exports: [AddResourceDialogComponent],
  providers: [FilterResourceListPipe, DisplayResourcePipe, DisplaySystemPipe, ResourcesDaoService]
})
export class AddResourceDialogModule {}
